const WORD_RE = /[A-Za-z0-9\u00C0-\u024F\u0400-\u04FF]+(?:['’-][A-Za-z0-9\u00C0-\u024F\u0400-\u04FF]+)*/g;
const MD_NOISE = /(!?\[([^\]]*)\]\([^)]*\))|[#>*_`~|]|^\s*[-+]\s|^\s*\d+\.\s/gm;

export const plainText = (md) => (md || "").replace(MD_NOISE, (m, a, label) => label ?? (m.includes("\n") ? "\n" : ""));

const ANNOT = /```note\n[\s\S]*?```|^\\?\[\\?\^[\w-]+\\?\]:.*$|\\?\[\\?\^[\w-]+\\?\]/gm;

export const countWords = (md) => ((md || "").replace(ANNOT, " ").replace(MD_NOISE, (m, a, label) => label || " ").match(WORD_RE) || []).length;

export const PAGE_SIZES = {
  letter: { label: "Letter", w: 816, h: 1056 },
  a4: { label: "A4", w: 794, h: 1123 },
};

export const VISIBILITY = [
  ["private", "Private (only me)"],
  ["published", "Visible to editors & viewers"],
  ["scheduled", "Visible from a set date"],
];

export const visibilityLabel = (s) => {
  if (s.visibility === "published") return "Visible to team";
  if (s.visibility === "scheduled") return s.publish_at && new Date(s.publish_at) <= new Date() ? "Visible to team" : `Visible from ${new Date(s.publish_at).toLocaleString()}`;
  return "Private";
};

export const fmtNum = (n) => Number(n || 0).toLocaleString();

export const chapterLabel = (n, title) => (title ? `Chapter ${n} · ${title}` : `Chapter ${n}`);

export const readMinutes = (words, wpm = 238) => (words ? Math.max(1, Math.round(words / (wpm || 238))) : 0);

export const fmtMinutes = (m) => (m >= 60 ? `${Math.floor(m / 60)} h ${m % 60} min` : `${m} min`);

const p2 = (n) => String(n).padStart(2, "0");
export const localDay = (d) => `${d.getFullYear()}-${p2(d.getMonth() + 1)}-${p2(d.getDate())}`;
export const utcHour = (d) => d.toISOString().slice(0, 13);
